(() => {
  const root = document.querySelector('#xcsub');
  if (!root || root.dataset.flipReady) return;
  root.dataset.flipReady = 'true';
  function setFace(panel, open) {
    const button = panel.querySelector('.plan-flip__toggle');
    panel.dataset.open = String(open);
    button.setAttribute('aria-expanded', String(open));
    button.querySelector('.plan-flip__label').textContent = open ? 'Back to features' : 'Learn more';
    for (const [selector, hidden] of [['.plan-flip__front', open], ['.plan-flip__back', !open]]) {
      const face = panel.querySelector(selector);
      face.inert = hidden;
      face.setAttribute('aria-hidden', String(hidden));
    }
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('.plan-flip__toggle');
    if (!button) return;
    const panel = button.closest('.plan-flip');
    setFace(panel, panel.dataset.open !== 'true');
  });
  root.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const panel = event.target.closest('.plan-flip[data-open="true"]');
    if (!panel) return;
    setFace(panel, false);
    panel.querySelector('.plan-flip__toggle').focus();
  });
})();
